'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$35() {
  this.bhu = null;
  this.bhs = null;
  this.bht = false;
  this.bhq = null;
  this.bhr = false;
  this.bhv = false;
  this.bhw = false;
  this.bhu = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$35 as $c_Lpresto_PrestoRouter$$anon$35 };
$p = $c_Lpresto_PrestoRouter$$anon$35.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$35;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$35() {
}
export { $h_Lpresto_PrestoRouter$$anon$35 as $h_Lpresto_PrestoRouter$$anon$35 };
$h_Lpresto_PrestoRouter$$anon$35.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bhu;
});
$p.t = (function() {
  if ((!this.bht)) {
    this.bhs = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("token", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bht = true;
  }
  return this.bhs;
});
$p.ae = (function() {
  if ((!this.bhr)) {
    this.bhq = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bhr = true;
  }
  return this.bhq;
});
$p.w = (function() {
  if ((!this.bhw)) {
    this.bhv = false;
    this.bhw = true;
  }
  return this.bhv;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$35 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$35, "presto.PrestoRouter$$anon$35", ({
  O1: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$35 as $d_Lpresto_PrestoRouter$$anon$35 };
//# sourceMappingURL=presto.-Presto-Router$$anon$35.js.map
